var React = require('react');

function TargetInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"12","cy":"12","r":"3","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"9","key":1}),React.createElement("path",{"d":"M12 1v2m0 18v2m11-11h-2M3 12H1","key":2})]));
}

TargetInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TargetInline;

TargetInline.default = TargetInline;
